import React from "react";
import { getDisplayName } from "utils/functions";
import { ParamsContext } from "./ParamsContext";

export function withParams(Component) {
  let comp = function ParamsComponent(props) {
    return <ParamsContext.Consumer>{params => <Component {...props} params={params} />}</ParamsContext.Consumer>;
  };
  comp.displayName = `withParams(${getDisplayName(Component)})`;
  return comp;
}
